<template>
	<v-menu
		ref="menu"
		:close-on-content-click="false"
		v-model="menu"
		:nudge-right="40"
		:return-value.sync="date"
		transition="scale-transition"
		offset-y
		min-width="290px"
	>
		<template v-slot:activator="{ on }">
			<v-text-field
				:value="type === 'month' ? month : date"
				:label="label"
				:clearable="clearable"
				:dense="dense"
				prepend-icon="fa-calendar-alt"
				readonly
				:disabled="disabled"
				v-on="on"
				:error-count="3"
				:error-messages="errors"
				@click:clear="onInput(null)"
			></v-text-field>
		</template>
		<v-date-picker
			:value="date"
			@input="onInput($event)"
			no-title
			scrollable
			:type="type"
		></v-date-picker>
	</v-menu>
</template>

<script>
import moment from 'moment'

export default {
	props: {
		value: String,
		label: String,
		clearable: Boolean,
		disabled: Boolean,
		dense: Boolean,
		type: String,
		errors: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			menu: false,
		}
	},
	computed: {
		month() {
			return this.value && this.value !== '' ? moment(this.value).format('MMMM YYYY') : ''
		},
		date() {
			return this.value && this.value !== '' ? moment(this.value).format('YYYY-MM-DD') : ''
		},
	},
	methods: {
		onInput(event) {
			this.$refs.menu.save(event)
			this.$emit('input', event)
		},
	},
}
</script>
